import React from 'react';
import Track from '../components/track/form';

function trackpage() {
  return (
    <div>
        <Track/>
    </div>
  )
}

export default trackpage



// <button class="button1" type="button" data-uk-toggle="target: #offcanvas-push"> 
// Track
// </button>
// <div id="offcanvas-push" uk-offcanvas="mode: push; overlay: true">
//   <div class="uk-offcanvas-bar">
//     <label>AWB Number </label>
//     <input type="text" name="" id="" className="uk-margin-small-top" onChange={(e)=> setTrackID(e.target.value)} />
//     <button type="button" className="uk-margin-small-top" onClick={handleTrackClick}  >
//       Track location
//     </button>
//     <div>
//       {trackingData && (
//       <div className="timeline">
//         {trackingData.map((item, index) => (
//           <div key={index} className="timeline-item">
//             <div className="timeline-icon">
//               <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                 {/* Replace with appropriate icon path */}
//                 <path d="M12 2l10 10-10 10-10-10L12 2z"/>
//               </svg>
//             </div>
//             <div className="timeline-content">
//               <h3>{item.adminStatus}</h3>
//               <p>{item.createdOn}</p>
//               <p>{item.date}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//       )}
//     </div>   
//   </div>
// </div>


// const [trackingData, setTrackingData] = useState(null);
// const [loading, setLoading] = useState(false);
// const [error, setError] = useState(null);
// const [trackID, setTrackID] = useState('');

// const handleTrackClick = async () => {
//   setLoading(true);
//   setError(null);
//   try {
//     const response = await fetch(`${process.env.REACT_APP_API_URL}/BookingScanning/GetAWBillTracking?AWBillNo=${trackID}`);
//     const result = await response.json();
//     setTrackingData(result.trackingDetails);
//     console.log(result.trackingDetails);
//   } catch (err) {
//     setError('Error fetching tracking data');
//   } finally {
//     setLoading(false);
//   }
// };